import { Status, Wrapper } from '@googlemaps/react-wrapper'
import { Spinner } from 'components/shared/Spinner'
import {
  FC,
  ReactElement,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react'
import { BugsnagClient } from 'utils/bugsnagClient'

const MapComponent = ({
  eventAddress,
}: {
  eventAddress: string
}): ReactElement => {
  const [geocoderResult, setGeocoderResult] =
    useState<google.maps.GeocoderResult>()
  const [status, setStatus] = useState<google.maps.GeocoderStatus>()
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (typeof window === 'undefined' || !ref.current) return
    const geocoder = new google.maps.Geocoder()
    const map = new window.google.maps.Map(ref.current, {
      zoom: 18,
    })

    let marker: google.maps.Marker
    geocoder.geocode({ address: eventAddress }, (results, status) => {
      setStatus(status)
      if (status !== google.maps.GeocoderStatus.OK || !results) {
        BugsnagClient.notify(new Error(status))
        return
      }
      const geocoderResult = results[0]
      setGeocoderResult(geocoderResult)
      map.setCenter(geocoderResult.geometry.location)

      marker = new google.maps.Marker({
        map: map,
        position: geocoderResult.geometry.location,
      })
    })

    return () => {
      map && map.unbindAll()
      marker && marker.unbindAll()
    }
  }, [eventAddress])

  const handleClickMap = useCallback(() => {
    if (!geocoderResult) return

    const { location } = geocoderResult.geometry
    // NOTE: 別タブでGoogleマップを起動して特定のアクションを実行する https://developers.google.com/maps/documentation/urls/get-started?hl=ja#search-parameters
    window.open(
      `https://www.google.com/maps/search/?api=1&query=${location.lat()},${location.lng()}`,
      '_blank',
    )
  }, [geocoderResult])

  // 不正な住所などでマップを読み込めない場合は何も表示しない
  if (status && status !== google.maps.GeocoderStatus.OK) return <></>

  return (
    <div
      ref={ref}
      id="map"
      style={{ height: '109px' }}
      onClick={() => handleClickMap()}
    />
  )
}

export const GoogleMapSection: FC<{ eventAddress: string }> = ({
  eventAddress,
}) => {
  return (
    <Wrapper
      apiKey={process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY || ''}
      render={(status: Status): ReactElement => {
        if (status === Status.LOADING) return <Spinner />
        return <MapComponent eventAddress={eventAddress} />
      }}
    />
  )
}
